module.exports = __webpack_public_path__ + "static/media/21ECLAC8.4fe28134.jpg";